import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const FilterBox = props => (
  <div className={Styles['filter-box-container']}>
    <div>
      <span className={Styles['filter-item']}>Filter By :</span>
      <select className={`${Styles['filter-item']} ${Styles.disabled}`} disabled="disabled">
        <option>service</option>
        <option>Option</option>
        <option>Option</option>
        <option>Option</option>
      </select>
      <button
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onClick={props.setFilterByRating(5, props.orderDetail.id)}
        disabled="disabled"
      >
        5 start
      </button>
      <button
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onClick={props.setFilterByRating(4, props.orderDetail.id)}
        disabled="disabled"
      >
        4 start
      </button>
      <button
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onClick={props.setFilterByRating(3, props.orderDetail.id)}
        disabled="disabled"
      >
        3 start
      </button>
      <button
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onClick={props.setFilterByRating(2, props.orderDetail.id)}
        disabled="disabled"
      >
        2 start
      </button>
      <button
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onClick={props.setFilterByRating(1, props.orderDetail.id)}
        disabled="disabled"
      >
        1 start
      </button>
    </div>
    <div>
      <span className={Styles['filter-item']}>Sort By :</span>
      <select
        className={`${Styles['filter-item']} ${Styles.disabled}`}
        onChange={props.setFilterSortReview(props.filterReview, props.orderDetail.id)}
        disabled="disabled"
      >
        <option value="DESC">Newest</option>
        <option value="ASC">Oldest</option>
      </select>
    </div>
  </div>
)

FilterBox.propTypes = {
  setFilterByRating: PropTypes.func.isRequired,
  orderDetail: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  setFilterSortReview: PropTypes.func.isRequired,
  filterReview: PropTypes.shape({}).isRequired,
}

export default FilterBox
